import { gql } from '@apollo/client';

export const DELETE_DEAL_CARVE = gql`
  mutation DeleteDealCarve($id: ID!, $offeringId: ID!, $buyerCompanyId: ID!) {
    deleteDealCarve(input: { id: $id, offering_id: $offeringId, buyer_company_id: $buyerCompanyId })
  }
`;
